import { render, staticRenderFns } from "./AriaPanel.vue?vue&type=template&id=6554bc96&scoped=true&"
import script from "./AriaPanel.vue?vue&type=script&lang=js&"
export * from "./AriaPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554bc96",
  null
  
)

export default component.exports